import { useEffect, useState } from "react";

const BookmakerTable = ({ oddsData, prevOddsRef, eventSummary, onFilterChange }) => {
  const [bookType, setBookType] = useState("my");
  const [oddsChanges, setOddsChanges] = useState({});

  const bookmakerData = oddsData?.bookmaker?.[0];
  const sections = bookmakerData?.section || [];
  const teamsExposure = eventSummary?.teams || [];

  const handleBookTypeChange = (type) => {
    setBookType(type);
    if (onFilterChange) onFilterChange(type);
  };

  useEffect(() => {
    if (!bookmakerData) return;
    const changes = {};
    sections.forEach((section) => {
      section.odds.forEach((odd) => {
        const key = `${section.sid}_${odd.oname}`;
        const prevOdd = prevOddsRef.current[key];
        if (prevOdd !== undefined && odd.odds < prevOdd) {
          changes[key] = true;
          setTimeout(() => {
            setOddsChanges((prev) => { const n = { ...prev }; delete n[key]; return n; });
          }, 2000);
        }
        prevOddsRef.current[key] = odd.odds;
      });
    });
    if (Object.keys(changes).length > 0) setOddsChanges(changes);
  }, [oddsData, sections, prevOddsRef]);

  const getOddsByName = (section, oddName) => section.odds?.find(o => o.oname === oddName)?.odds || 0;
  const isOddDecreased = (sid, name) => oddsChanges[`${sid}_${name}`];
  const getExposureBySid = (sid) => teamsExposure.find(t => t.sid === sid)?.exposure || 0;

  return (
    <div className="betting-table bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0c1524] to-[#162032] px-4 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-1 h-5 bg-teal-400 rounded-full" />
          <span className="text-white font-semibold text-sm tracking-wide">Bookmaker</span>
        </div>
        <div className="flex gap-0.5">
          {['all', 'my'].map(t => (
            <button
              key={t}
              onClick={() => handleBookTypeChange(t)}
              className={`px-3 py-1 text-xs font-semibold rounded-md transition-all capitalize ${
                bookType === t
                  ? 'bg-teal-500 text-white'
                  : 'bg-white/10 text-white/70 hover:bg-white/20'
              }`}
            >
              {t === 'all' ? 'All Book' : 'My Book'}
            </button>
          ))}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr>
              <th className="p-2 border border-slate-200 text-left text-xs font-bold text-slate-500 bg-slate-50" style={{ width: '58%' }}>Market</th>
              <th className="p-2 border border-slate-200 text-center text-xs font-bold text-white bg-[#72bbef]" style={{ width: '21%' }}>LAGAI</th>
              <th className="p-2 border border-slate-200 text-center text-xs font-bold text-white bg-[#f994ba]" style={{ width: '21%' }}>KHAI</th>
            </tr>
          </thead>
          <tbody>
            {sections.length === 0 ? (
              <tr>
                <td colSpan="3" className="py-8 text-center text-slate-400 text-xs">No bookmaker data</td>
              </tr>
            ) : (
              sections.map((section) => {
                const backOdds = getOddsByName(section, "back1");
                const layOdds  = getOddsByName(section, "lay1");
                const exposure = getExposureBySid(section.sid);
                const isSuspended =
                  section.gstatus === 'SUSPENDED' ||
                  (backOdds === 0 && layOdds === 0) ||
                  backOdds >= 100 ||
                  layOdds >= 100;

                return (
                  <tr key={section.sid} className="border-b border-slate-100">
                    <td className="p-2 border border-slate-200 bg-white">
                      <div className="font-semibold text-slate-800 text-xs">{section.nat}</div>
                      <div className={`text-xs font-medium mt-0.5 ${exposure >= 0 ? 'text-emerald-600' : 'text-red-500'}`}>
                        {exposure.toFixed(2)}
                      </div>
                    </td>
                    {isSuspended ? (
                      <td colSpan={2} className="odd-susp border border-slate-200 text-center p-2">
                        <span className="font-bold text-red-400 text-sm tracking-widest">SUSPENDED</span>
                      </td>
                    ) : (
                      <>
                        <td className={`border border-slate-200 text-center p-2 transition-colors duration-300 ${
                          isOddDecreased(section.sid, 'back1') ? 'odd-flash' : 'odd-back'
                        }`}>
                          <span className="font-bold text-slate-800 text-sm">{backOdds || '-'}</span>
                        </td>
                        <td className={`border border-slate-200 text-center p-2 transition-colors duration-300 ${
                          isOddDecreased(section.sid, 'lay1') ? 'odd-flash' : 'odd-lay'
                        }`}>
                          <span className="font-bold text-slate-800 text-sm">{layOdds || '-'}</span>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookmakerTable;
